// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-bottom-6[data-v-01c28396] {\n  margin-bottom: 6px;\n}\n.margin-bottom-10[data-v-01c28396] {\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
